import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_modal = _resolveComponent("new-modal")!

  return (_openBlock(), _createBlock(_component_new_modal, {
    title: "Смена волны",
    overflow: false,
    loading: _ctx.state.is_loading,
    onSubmit: _ctx.onSubmit,
    onCancel: _ctx.onCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_new_select, {
        value: _ctx.state.wave_id,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.wave_id) = $event)),
        placeholder: "Выберите волну",
        options: _ctx.waves_state.list,
        loading: _ctx.waves_state.is_loading,
        failed: _ctx.waves_state.is_failed,
        "error-text": "При получении списка волн произошла ошибка",
        label: "title",
        "search-by": "title",
        "search-without-refresh": "",
        disabled: _ctx.state.is_loading,
        "is-invalid": _ctx.validation$.wave_id.$error,
        "validation-errors": _ctx.validation$.wave_id.$errors
      }, null, 8, ["value", "options", "loading", "failed", "disabled", "is-invalid", "validation-errors"])
    ]),
    _: 1
  }, 8, ["loading", "onSubmit", "onCancel"]))
}